import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-dd2051794f/2/root/.yarn/berry/cache/next-npm-14.2.12-db57ef3403-10c0.zip/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-dd2051794f/2/root/.yarn/berry/cache/next-npm-14.2.12-db57ef3403-10c0.zip/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/ketcher-react-virtual-4497bf2d8f/2/root/.yarn/berry/cache/ketcher-react-npm-3.12.0-dev.1-265c92660e-10c0.zip/node_modules/ketcher-react/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["TeamProvider"] */ "/app/components/team-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/toaster.tsx");
